export interface Signature {
  Element: HTMLButtonElement;
  Blocks: { default: [] };
}

import templateOnly, { type TOC } from "@ember/component/template-only";
const LinkButtonComponent: TOC<Signature> = templateOnly();
export default LinkButtonComponent;
